export enum EToastType {
  ERROR,
  INFO,
  SUCCESS,
  WARNING,
}
